/**
 * Проверяет, является ли ошибка специфической ошибкой упаковки,
 * которая требует принудительного подтверждения
 * @param error - данные ошибки
 * @returns true если это ошибка, требующая подтверждения упаковки
 */
export const isPackingConfirmationError = (error: unknown): boolean => {
  try {
    if (typeof error !== 'object' || error === null) {
      return false;
    }

    const errorObj = error as Record<string, unknown>;

    if (
      typeof errorObj.message === 'string' &&
      typeof errorObj.code === 'number'
    ) {
      const result =
        errorObj.message === 'Нет доступных для продажи торговых предложений' &&
        errorObj.code === 3;
      return result;
    }

    if (
      typeof errorObj.response !== 'undefined' &&
      errorObj.response !== null
    ) {
      return false;
    }

    if (typeof errorObj.meta !== 'object' || errorObj.meta === null) {
      return false;
    }

    const meta = errorObj.meta as Record<string, unknown>;

    if (typeof meta.error !== 'object' || meta.error === null) {
      return false;
    }

    const metaError = meta.error as Record<string, unknown>;

    // Проверяем специфическое сообщение и код ошибки
    const result =
      typeof metaError.message === 'string' &&
      metaError.message === 'Нет доступных для продажи торговых предложений' &&
      typeof metaError.code === 'number' &&
      metaError.code === 3;

    return result;
  } catch {
    return false;
  }
};
